var filterBar = document.getElementById('ballot-filter');
var searchInput = document.getElementById('ballot-search-input');
var searchList = document.getElementById('ballot-search-listbox');
var searchClear = document.getElementById('ballot-search-clear');
var resultsCount = document.getElementById('ballot-results-count');

if (filterBar) {
  var buttons = Array.prototype.slice.call(
    filterBar.querySelectorAll('[data-filter]')
  );

  function normalize(str) {
    return str.toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  var entries = Array.prototype.slice
    .call(document.querySelectorAll('.office[data-race-category]'))
    .map(function(office) {
      var titleEl = office.querySelector('.office__title');
      return {
        office: office,
        title: titleEl ? titleEl.textContent.trim() : office.id,
        category: office.dataset.raceCategory,
      };
    });

  function getActiveFilter() {
    var active = buttons
      .filter(function(b) {
        return b.classList.contains('is-active');
      })
      .map(function(b) {
        return b.dataset.filter;
      });
    var showAll = active.length === 0 || active.indexOf('all') !== -1;
    return { active: active, showAll: showAll };
  }

  var baseLabels = {};
  buttons.forEach(function(btn) {
    baseLabels[btn.dataset.filter] = btn.textContent.trim();
  });

  function updateCounts() {
    var categoryCounts = {};
    var total = 0;

    entries.forEach(function(entry) {
      var category = entry.office.dataset.raceCategory;
      var count = entry.office.querySelectorAll('.seat').length;
      categoryCounts[category] = (categoryCounts[category] || 0) + count;
      total += count;
    });

    buttons.forEach(function(btn) {
      var filter = btn.dataset.filter;
      var count = filter === 'all' ? total : categoryCounts[filter] || 0;
      btn.textContent = baseLabels[filter] + ' (' + count + ')';
    });
  }
  updateCounts();

  var officeContainer = entries.length ? entries[0].office.parentElement : null;
  var topLevelAds = officeContainer
    ? Array.prototype.filter.call(officeContainer.children, function(el) {
        return (
          el.classList.contains('plugin') &&
          el.classList.contains('plugin--centered')
        );
      })
    : [];

  var nestedAds = [];
  function refreshNestedAds() {
    var next = [];
    entries.forEach(function(entry) {
      Array.prototype.forEach.call(
        entry.office.querySelectorAll('.contests .plugin.plugin--centered'),
        function(el) {
          next.push(el);
        }
      );
    });
    nestedAds = next;
  }
  refreshNestedAds();

  function matchesSearch(entry, term) {
    return !term || normalize(entry.title).indexOf(normalize(term)) !== -1;
  }

  function apply() {
    var filter = getActiveFilter();
    var active = filter.active;
    var showAll = filter.showAll;
    var term = searchInput ? searchInput.value.trim() : '';
    var totalRaces = 0;
    var visibleRaces = 0;

    entries.forEach(function(entry) {
      var seats = Array.prototype.slice.call(
        entry.office.querySelectorAll('.seat')
      );
      totalRaces += seats.length;

      var categoryShown = showAll || active.indexOf(entry.category) !== -1;

      if (!categoryShown) {
        entry.office.hidden = true;
        return;
      }

      if (!term || matchesSearch(entry, term) || !seats.length) {
        entry.office.hidden = false;
        seats.forEach(function(seat) {
          seat.hidden = false;
        });
        visibleRaces += seats.length;
        return;
      }

      var anySeatMatches = false;
      seats.forEach(function(seat) {
        var titleEl = seat.querySelector('.seat__title');
        var seatTitle = titleEl ? titleEl.textContent.trim() : '';
        var seatMatches =
          !!seatTitle && normalize(seatTitle).indexOf(normalize(term)) !== -1;
        seat.hidden = !seatMatches;
        if (seatMatches) {
          anySeatMatches = true;
          visibleRaces++;
        }
      });
      entry.office.hidden = !anySeatMatches;
    });

    var isFiltered = !showAll || !!term;
    topLevelAds.forEach(function(ad) {
      ad.hidden = isFiltered;
    });
    nestedAds.forEach(function(ad) {
      ad.hidden = !!term;
    });

    if (resultsCount) {
      resultsCount.innerHTML =
        'Showing <strong>' +
        visibleRaces +
        '</strong> of <strong>' +
        totalRaces +
        '</strong> races. ';
    }
  }

  var seatEntries = [];
  function refreshSeatEntries() {
    var next = [];
    entries.forEach(function(entry) {
      Array.prototype.forEach.call(
        entry.office.querySelectorAll('.seat'),
        function(seat) {
          var titleEl = seat.querySelector('.seat__title');
          var title = titleEl ? titleEl.textContent.trim() : '';
          if (title) next.push({ title: title, category: entry.category });
        }
      );
    });
    seatEntries = next;
  }
  refreshSeatEntries();

  var contestsContainers = document.querySelectorAll('.office .contests');
  if (contestsContainers.length && window.MutationObserver) {
    var seatObserver = new MutationObserver(function() {
      refreshSeatEntries();
      refreshNestedAds();
      updateCounts();
      apply();
    });
    Array.prototype.forEach.call(contestsContainers, function(container) {
      seatObserver.observe(container, { childList: true, subtree: true });
    });
  }

  function scrollToAllRacesTop() {
    var heading = document.getElementById('all-races__heading');
    if (heading) heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  buttons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (btn.dataset.filter === 'all') {
        buttons.forEach(function(b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');
      } else {
        btn.classList.toggle('is-active');
        var allBtn = buttons.filter(function(b) {
          return b.dataset.filter === 'all';
        })[0];
        allBtn.classList.remove('is-active');

        var anyActive = buttons.some(function(b) {
          return (
            b.dataset.filter !== 'all' && b.classList.contains('is-active')
          );
        });
        if (!anyActive) allBtn.classList.add('is-active');
      }
      apply();

      scrollToAllRacesTop();
    });
  });

  if (searchInput && searchList) {
    var highlightedIndex = -1;
    var MAX_SUGGESTIONS = 8;

    function currentMatches() {
      var term = searchInput.value.trim();
      if (!term) return [];
      var filter = getActiveFilter();
      return entries
        .concat(seatEntries)
        .filter(function(entry) {
          return (
            (filter.showAll || filter.active.indexOf(entry.category) !== -1) &&
            matchesSearch(entry, term)
          );
        })
        .slice(0, MAX_SUGGESTIONS);
    }

    function renderList() {
      var matches = currentMatches();
      searchList.innerHTML = '';

      matches.forEach(function(entry, idx) {
        var li = document.createElement('li');
        li.className =
          'listbox__item' +
          (idx === highlightedIndex ? ' listbox__item--highlighted' : '');
        li.textContent = entry.title;
        li.addEventListener(
          'touchstart',
          function(event) {
            event.preventDefault();
            selectEntry(entry);
          },
          { passive: false }
        );
        li.addEventListener('mousedown', function(event) {
          event.preventDefault();
          selectEntry(entry);
        });
        li.addEventListener('mouseenter', function() {
          highlightedIndex = idx;
          renderList();
        });
        searchList.appendChild(li);
      });

      searchList.hidden = matches.length === 0;
      searchInput.setAttribute('aria-expanded', String(matches.length > 0));
    }

    function selectEntry(entry) {
      searchInput.value = entry.title;
      searchList.hidden = true;
      highlightedIndex = -1;
      updateClearButton();
      apply();
      scrollToAllRacesTop();
    }

    function updateClearButton() {
      if (searchClear) searchClear.hidden = !searchInput.value;
    }

    if (searchClear) {
      searchClear.addEventListener('click', function() {
        searchInput.value = '';
        searchList.hidden = true;
        highlightedIndex = -1;
        updateClearButton();
        apply();
        searchInput.focus();
      });
    }

    searchInput.addEventListener('input', function() {
      highlightedIndex = -1;
      renderList();
      updateClearButton();
    });

    updateClearButton();

    searchInput.addEventListener('keydown', function(event) {
      var count = currentMatches().length;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (!count) return;
        highlightedIndex = Math.min(highlightedIndex + 1, count - 1);
        renderList();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (!count) return;
        highlightedIndex = Math.max(highlightedIndex - 1, 0);
        renderList();
      } else if (event.key === 'Enter') {
        var matches = currentMatches();
        if (highlightedIndex > -1 && matches[highlightedIndex]) {
          event.preventDefault();
          selectEntry(matches[highlightedIndex]);
        }
      } else if (event.key === 'Escape') {
        searchList.hidden = true;
        highlightedIndex = -1;
      }
    });

    searchInput.addEventListener('blur', function() {
      setTimeout(function() {
        searchList.hidden = true;
      }, 0);
    });

    searchInput.addEventListener('focus', function() {
      if (searchInput.value.trim()) renderList();
    });
  }

  apply();
}

var jumpToPersonalizedLink = document.getElementById(
  'jump-to-personalized-link'
);
if (jumpToPersonalizedLink) {
  jumpToPersonalizedLink.addEventListener('click', function(event) {
    event.preventDefault();
    var heading = document.getElementById('your-races-promo__heading');
    if (!heading) return;

    heading.scrollIntoView({ behavior: 'smooth', block: 'start' });

    var clearBodyOverflowLock = function() {
      if (document.body.style.overflow) document.body.style.overflow = '';
    };
    if ('onscrollend' in window) {
      window.addEventListener('scrollend', clearBodyOverflowLock, {
        once: true,
      });
    } else {
      setTimeout(clearBodyOverflowLock, 600);
    }
  });
}
